import React from 'react';
import { FiGlobe, FiCode, FiShield } from 'react-icons/fi';

export function IntegrationStep({
  selectedIntegrations,
  onToggleIntegration,
}) {
  const integrations = [
    {
      id: 'hostedCheckout',
      label: 'Hosted Checkout',
      description: 'Embedded payment page with minimal coding',
      icon: FiGlobe,
      features: [
        'No PCI compliance required',
        'Quick implementation',
        'Fully responsive design',
        'Customizable appearance',
      ],
    },
    {
      id: 'directApi',
      label: 'Terminal API',
      description: 'Integrate a terminal using a TNS API',
      icon: FiCode,
      features: [
        'Complete customization',
        'Server-to-server integration',
        'Advanced features',
        'Requires PCI compliance',
      ],
    },
    {
      id: 'androidPayApp',
      label: 'Android Payment App',
      description: 'Leverage the Android Payment App integrated into Orchestration',
      icon: FiCode,
      features: [
        'Allow a customer to develop their own android terminal app',
        'Use the Android Payment App for payments',
        'API integration',
        'Reduced PCI compliance',
      ],
    }
  ];

  return (
    <div className="space-y-6 max-w-3xl mx-auto">
      {integrations.map((integration) => {
        const Icon = integration.icon;
        return (
          <button
            key={integration.id}
            onClick={() => onToggleIntegration(integration.id)}
            className={`w-full p-6 rounded-lg border-2 transition-all text-left ${
              selectedIntegrations.includes(integration.id)
                ? 'border-blue-500 bg-blue-50'
                : 'border-gray-200 hover:border-blue-200'
            }`}
          >
            <div className="flex items-start space-x-4">
              <div
                className={`p-3 rounded-full ${
                  selectedIntegrations.includes(integration.id)
                    ? 'bg-blue-500 text-white'
                    : 'bg-gray-100 text-gray-500'
                }`}
              >
                <Icon className="w-6 h-6" />
              </div>
              <div className="flex-1">
                <h3 className="font-medium text-gray-900">{integration.label}</h3>
                <p className="text-sm text-gray-500 mt-1">
                  {integration.description}
                </p>
                <div className="mt-4 grid grid-cols-2 gap-2">
                  {integration.features.map((feature, index) => (
                    <div
                      key={index}
                      className="flex items-center text-sm text-gray-600"
                    >
                      <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mr-2" />
                      {feature}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </button>
        );
      })}
    </div>
  );
}